import * as React from 'react';
import { Controller, MainMenu, Menu, StateManager, Toolbar } from '@tencent/workbench';
import { InsertChartFeature } from './insert-chart-feature';
import { defaultMenu, config, TOOLBAR_ITEMS } from './config';
import { wrapIdForBig } from '@src/framework/workbench/util/wrap-id-util';

@Controller({
    menuItems: defaultMenu,
    toolbarItems: TOOLBAR_ITEMS,
})
export class InsertChartController {
    constructor(
        private readonly feature: InsertChartFeature,
        private readonly stateManager: StateManager,
    ) {
    }

    @Menu(config.id, 'onClick')
    public onClick() {
        return false;
    }

    @Toolbar(wrapIdForBig(config.id), 'dropdownContent')
    public getInsertTableDropdownContent() {
        return <MainMenu align="left" name={config.id} mode="menu"/>;
    }

    @Toolbar(wrapIdForBig(config.id), 'onDropdownVisibleChange')
    public onDropdownVisibleChange(visible: boolean) {
        this.feature.updateDropdownVisible(visible, config.id);
    }
}
